/**
 * The memo's Share button (memo co-editing): a deal IS its folder, so sharing
 * the memo is sharing the folder — the Deal Room's own Share dialog, for the
 * deal's folder, with who already has it. The folder tree is read when the
 * dialog opens, not before.
 */

import React from "react";

import { useFileLibrary } from "../../hooks/useFileLibrary";
import ModalDialog from "../ModalDialog";
import ShareFolderDialog from "../Files/ShareFolderDialog";

export interface MemoShareFolderProps {
	folderId: number;
	dealName: string;
	onClose: () => void;
}

const MemoShareFolder: React.FC<MemoShareFolderProps> = ({ folderId, dealName, onClose }) => {
	const library = useFileLibrary();
	const deal = library.findDeal(folderId);
	if (library.loading && !deal) {
		return (
			<ModalDialog titleId="memo-share-loading" onClose={onClose} size="md">
				<p id="memo-share-loading" className="px-6 py-6 text-sm text-text-muted">
					Loading the deal's folder…
				</p>
			</ModalDialog>
		);
	}
	if (!deal) {
		return (
			<ModalDialog titleId="memo-share-missing" onClose={onClose} size="md">
				<p id="memo-share-missing" className="px-6 py-6 text-sm text-text-muted">
					{library.error ?? `The folder behind ${dealName} is not in your files, so it cannot be shared from here.`}
				</p>
			</ModalDialog>
		);
	}
	const folder = deal.node.folder;
	return (
		<ShareFolderDialog
			folderId={deal.id}
			folderName={deal.name}
			fileCount={deal.files.length}
			subFolderCount={deal.node.sub_folders.length}
			current={folder.shared?.folder_id === deal.id ? folder.shared : null}
			onClose={onClose}
		/>
	);
};

export default MemoShareFolder;
